<template>
  <div id="email-quote-template">


    <table class="container" cellpadding="0" cellspacing="0" role="presentation">
      <tr>
        <td>
          <table width="100%" cellpadding="0" cellspacing="0" role="presentation">
            <tr>
              <td class="header" width="10%">

                <img v-if="emailData && emailData.logo"
                  :src="'https://service.secureoffersites.com/images/GetLibraryImage?fileNameOrId=' + emailData.logo + '&Width=0&Height=0&logo=y'"
                  :alt="vehicleDisplayName" style="max-width: 120px;" />
                <img :src="websiteInfo.logoImage" :alt="vehicleDisplayName" style="max-width:120px;" v-else />
              </td>
              <td class="header-text" width="90%" valign="middle" style="font-size: 10px;">
                <table>
                  <tr>
                    <td v-if="websiteInfo.salesNumber" style="padding: 0 4px;">
                      <span>
                        <img style="filter: invert(1);height: 10px;"
                          src="../../../../../../images/chat-widget/Phone.png" alt="" srcset="">
                      </span> Sales:
                      {{ websiteInfo.salesNumber }}
                    </td>
                    <td v-if="websiteInfo.serviceNumber" style="padding: 0 4px;">
                      <span>
                        <img style="filter: invert(1);height: 10px;"
                          src="../../../../../../images/chat-widget/Service.png" alt="" srcset="">
                      </span> Service:
                      {{ websiteInfo.serviceNumber }}
                    </td>
                    <td v-if="websiteInfo.fullAddress" style="padding: 0 4px;">
                      <span>
                        <img style="filter: invert(1);height: 10px;"
                          src="../../../../../../images/chat-widget/Location.png" alt="" srcset="">
                      </span>
                      {{ websiteInfo.fullAddress }}
                    </td>
                    <td v-if="websiteInfo.contactEmail" style="padding: 0 4px;">{{ websiteInfo.contactEmail }}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </td>
      </tr>

      <tr>
        <td class="vehicle-info">
          <table width="100%" cellpadding="0" cellspacing="0" role="presentation" id="vehicle-info-table">
            <tr>
              <td width="50%" valign="top" class="full_width">
                <p class="vehicle-name">{{ vehicleDisplayName }}
                </p>
                <p class="vehicle-details  mb-0">
                <table class="ft-10">
                  <tr>
                    <td>Exterior</td>
                    <td class="px-1">
                      <span :style="getVehicleIntExteriorColorStyle(
                        vehicleInfo.extColorHexCode,
                        vehicleInfo.ext_Color_Generic
                      )" style=" width:10px; height:10px; border-radius:50%; display:inline-block;"></span>
                      {{ vehicleInfo.exteriorColor }}


                    </td>
                  </tr>
                  <tr>
                    <td>Interior</td>
                    <td class="px-1">
                      <span :style="getVehicleIntExteriorColorStyle(
                        vehicleInfo.intColorHexCode,
                        vehicleInfo.int_Color_Generic
                      )" style=" width:10px; height:10px;border-radius:50%;
                        display:inline-block;"></span>
                      <span>{{ vehicleInfo.interiorColor }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td style="padding:5px 4px;">
                      <p style="margin: 0;font-size: 10px !important;">VIN: <b>{{ vehicleInfo.vin }}</b></p>

                      <p style="margin: 0;font-size: 10px !important;">Model Code: <b>{{ vehicleInfo.modelNumber
                      }}</b>
                      </p>
                    </td>

                    <td style="padding:5px 4px;">
                      <p style="margin: 0;font-size: 10px !important;"> Stock # <b>{{ vehicleInfo.stock }}</b></p>
                      <p style="margin: 0;font-size: 10px !important;">Model Code: <b>{{ vehicleInfo.modelNumber
                      }}</b>
                      </p>
                    </td>
                  </tr>
                </table>
                </p>


                <div class="border max-width-80 price_tag"
                  style="border:1px solid #eee; border-radius:8px; padding:10px;"
                  v-if="msrpDetails && msrpDetails.length && msrpDetails.slice(0, -1).length">
                  <table role="presentation" cellpadding="0" cellspacing="0" width="100%"
                    style="font-size:10px; border-collapse:collapse;">
                    <tr v-for="(item, index) in msrpDetails.slice(0, -1)" :key="'main-' + index">
                      <td>{{ item.key }}</td>
                      <td v-if="item.value" style="text-align:right; font-weight:bold;">{{ item.value }}</td>
                    </tr>

                  </table>
                </div>

                <p v-if="msrpDetails && msrpDetails.length"
                  style="font-size:28px; font-weight:bold; color:#000000; margin:10px 0 0 0;">
                  <b v-if="msrpDetails[msrpDetails.length - 1].value">
                    {{ msrpDetails[msrpDetails.length - 1].value }}
                  </b>
                </p>
                <p style="font-size:9px; color:#555555;">{{ emailCashDisclaimer }}</p>

              </td>
              <td width="50%" align="right" valign="middle" class="full_width">
                <div v-if="emailData && (emailData.firstName || emailData.lastName)">
                  <p style="font-size:20px; color:#555555; margin:0 0 10px 0;font-weight: bold;">{{ emailData.firstName
                  }} {{
                      emailData.lastName }}</p>
                </div>
                <div v-if="emailData && emailData.email">
                  <p style="font-size:12px; color:#555555; margin:0 0 10px 0;">{{ emailData.email }}</p>
                </div>
                <div v-if="emailData && emailData.transactUrl">
                  <p style="font-size:12px; color:#555555; margin:10px 0 20px 0;">
                    <a :href="emailData.transactUrl" target="_blank" rel="noopener noreferrer" :style="{
                      backgroundColor: primaryColor,
                      color: '#fff',
                      textDecoration: 'none',
                      padding: '8px 11px',
                      borderRadius: '50px'
                    }">Change
                      Payments</a>
                  </p>
                </div>
                <div style="margin-top: 10px;">
                  <img :src="vehicleInfo.vehicleImg" alt="" style="max-width:100%;border-radius: 10px;" />
                </div>
              </td>
            </tr>

          </table>
        </td>
      </tr>


      <tr v-if="leaseGrouped && leaseGrouped.length">
        <td class="options-section">
          <p class="options-title">Leasing Options</p>
          <table width="100%" cellpadding="0" cellspacing="10" role="presentation">
            <tr v-for="(row, rowIndex) in leaseGrouped" :key="rowIndex">
              <td v-for="(item, index) in row" :key="index" width="32%" valign="top" class="option-box">
                <table width="100%" cellpadding="0" role="presentation">
                  <tr>
                    <td class="option-duration"> {{ item.Term }} months</td>
                  </tr>
                  <tr>
                    <td class="popular-option">
                      <span v-if="item.Term == '36'" :style="{ color: primaryColor }"
                        style="height:10px; padding-top:10px; font-weight:bold;font-size: 10px;">OUR MOST
                        POPULAR LEASING OPTION</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="option-price">{{ item.Payment }}</td>
                  </tr>
                  <tr>
                    <td class="option-terms">per
                      month lease payment for {{ item.Term }} months</td>
                  </tr>
                  <tr v-if="item.MailDisclaimer">
                    <td class="option-terms-conditions" style="font-size:9px; padding-top:5px;">{{
                      item.MailDisclaimer }}</td>
                  </tr>
                </table>
              </td>

            </tr>
          </table>
        </td>
      </tr>

      <tr v-if="leaseDetails && leaseDetails.length && leaseDetails[0].DigitalDisclaimer">
        <td class="disclaimer" style="font-size:9px; color:#aaaaaa; text-align:left; padding:0 20px 20px 20px;">
          {{ leaseDetails[0].DigitalDisclaimer }}
        </td>
      </tr>

      <tr>
        <td style="border-bottom: 1px solid #eeeeee;">

        </td>
      </tr>

      <tr v-if="financeGrouped && financeGrouped.length">
        <td class="options-section">
          <p class="options-title">Financing Options</p>
          <table width="100%" cellpadding="0" cellspacing="10" role="presentation">
            <tr v-for="(row, rowIndex) in financeGrouped" :key="rowIndex">
              <td v-for="(item, index) in row" :key="index" width="32%" valign="top" class="option-box">
                <table width="100%" cellpadding="0" cellspacing="0" role="presentation">
                  <tr>
                    <td class="option-duration">{{ item.Term }} months</td>
                  </tr>
                  <tr>
                    <td class="popular-option">
                      <span v-if="item.Term == '36'" :style="{ color: primaryColor }"
                        style="padding-top:10px; font-weight:bold;font-size: 10px;">OUR MOST
                        POPULAR FINANCE OPTION</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="option-price">{{ item.Payment }}</td>
                  </tr>
                  <tr>
                    <td class="option-terms">per
                      month lease payment for {{ item.Term }} months</td>
                  </tr>
                  <tr>
                    <td v-if="item.MailDisclaimer" class="option-terms-conditions"
                      style="font-size:9px; padding-top:5px;">{{ item.MailDisclaimer
                      }}</td>
                  </tr>
                </table>
              </td>

            </tr>
          </table>
        </td>
      </tr>
      <tr v-if="financeDetails && financeDetails.length > 0 && financeDetails[0].DigitalDisclaimer">
        <td class="disclaimer">
          {{ financeDetails[0].DigitalDisclaimer }}
        </td>
      </tr>

      <tr>
        <td style="border-bottom: 1px solid #eeeeee;">

        </td>
      </tr>

      <tr v-if="qualifiedData && qualifiedData.length">
        <td class="incentives-section">
          <p class="options-title" style="margin-bottom: 15px;text-align: center;">Additional Incentives
          </p>
          <table width="100%" cellpadding="0" cellspacing="10" role="presentation">
            <tr v-for="(row, rowIndex) in qualifiedDataGrouped" :key="rowIndex">
              <td v-for="(item, index) in row" :key="item.VIN" width="32%" valign="top" style="padding: 5px;"
                class="incentive-offer-box">
                <table width="100%" cellpadding="0" cellspacing="0" role="presentation">
                  <tr>
                    <td class="incentive-title" v-if="item.offertype"> {{ item.offertype }}</td>
                  </tr>
                  <tr>
                    <td class="incentive-amount" v-if="item.cash"> ${{ item.cash }}</td>
                  </tr>
                  <tr>
                    <td class="incentive-description" v-if="item.programname">{{
                      item.programname }}</td>
                  </tr>
                  <tr>
                    <td style="font-size:9px; padding-top:15px;color: #555555;" v-if="item.disclaimer">{{
                      item.disclaimer }}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </td>
      </tr>


    </table>

  </div>
</template>
<script>


import { isFordDealer } from "../../../../Events/FordDirect/FordCookieService";

export default {
  props: {
    vehicleInfo: {
      type: Object,
      required: false
    },
    msrpDetails: {
      type: Array,
      required: false
    },
    qualifiedData: {
      type: Array,
      required: false
    },
    paymentCollection: {
      type: Array,
      required: false
    },
    emailData: {
      type: Object,
      required: false
    },
  },
  data() {
    return {
      websiteInfo: {
        domain: window.domain || window.primaryDomain,
        fullAddress: window.fullAddress,
        salesNumber: window.salesNumber,
        serviceNumber: window.serviceNumber,
        contactEmail: window.contactEmail,
        logoImage: window.logoImage,
      },
      isFord: isFordDealer(window.IncentiveSource),
      emailCashDisclaimer: window.emailCashDisclaimer || "",
      primaryColor: window.primaryColor,
      financeDetails: [],
      leaseDetails: [],
    }
  },
  computed: {
    vehicleDisplayName() {
      if (!this.vehicleInfo) {
        return "";
      }
      const { year, make, model, trim } = this.vehicleInfo;
      return [year, make, model, trim].filter(Boolean).join(" ");
    },
    qualifiedDataGrouped() {
      if (!this.qualifiedData || !this.qualifiedData.length) {
        return [];
      }
      const chunkSize = 3;
      return this.chunkArray(this.qualifiedData, chunkSize);
    },
    leaseGrouped() {
      if (!this.paymentCollection || !this.paymentCollection.length) {
        return [];
      }
      const leaseDetails = this.paymentCollection.filter(item => item.OfferType === 'Closed End').sort((a, b) => {
        const paymentA = parseFloat(a.Payment.replace(/[$,]/g, ''));
        const paymentB = parseFloat(b.Payment.replace(/[$,]/g, ''));
        return paymentA - paymentB;
      })
        .sort((a, b) => {
          return parseInt(a.Term) - parseInt(b.Term);
        })
        .slice(0, 3);

      const chunkSize = 3;
      this.leaseDetails = leaseDetails;
      return this.chunkArray(leaseDetails, chunkSize);
    },
    financeGrouped() {
      if (!this.paymentCollection || !this.paymentCollection.length) {
        return [];
      }
      const financeDetails = this.paymentCollection
        .filter(item => item.OfferType === 'Loan')
        .sort((a, b) => {
          const paymentA = parseFloat(a.Payment.replace(/[$,]/g, ''));
          const paymentB = parseFloat(b.Payment.replace(/[$,]/g, ''));
          return paymentA - paymentB;
        })
        .sort((a, b) => {

          return parseInt(a.Term) - parseInt(b.Term);
        })
        .slice(0, 3);

      this.financeDetails = financeDetails;
      const chunkSize = 3;
      return this.chunkArray(financeDetails, chunkSize);
    },
  },
  methods: {
    getVehicleIntExteriorColorStyle(colorHexCode, colorGeneric) {
      if (colorHexCode === "" && colorGeneric === "") {
        return {
          "background-color": "transparent",
          border: "1px solid #ccc",
        };
      }

      const color = colorHexCode ? `#${colorHexCode}` : colorGeneric;
      return { "background-color": `${color} !important`, "border-color": `${color} !important` };
    },
    chunkArray(array, size) {
      const result = [];
      for (let i = 0; i < array.length; i += size) {
        result.push(array.slice(i, i + size));
      }
      return result;
    },
    formatDate(dateStr) {
      const date = new Date(dateStr)
      return date.toLocaleDateString()
    }
  },
  mounted() {
    console.log("Mounted AiEmailTemplate with vehicleInfo:", this.qualifiedData);
  }
}
</script>
<style lang="">

</style>
